<template>
  <v-container>
    <v-row no-guters>
      <v-dialog class="ma-0 pa-0" width="900px" v-model="showDialog" scrollable>
        <template v-if="showDialog">
          <Beneficiary
            @closeDialog="closeDialog"
            @getBenficaryDetails="getBenficaryDetails()"
            :showDialog="showDialog"
            :policy_number="recievedPolicy_number"
        /></template>
      </v-dialog>
      <v-dialog
        class="ma-0 pa-0"
        width="900px"
        v-model="showBusDialog"
        scrollable
      >
        <BusBeneficiary
          @closeBusDialog="closeBusDialog"
          :showBusDialog="showBusDialog"
      /></v-dialog>

      <v-col cols="12 ">
        <v-row no-gutters>
          <v-col lg="6" sm="12">
            <v-menu :offset-x="true" open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  rounded
                  color="primary"
                  class="me-2 mt-5 v-custome-btn pa-5"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark left>mdi-account-plus </v-icon>
                  {{ $t("add_bene_label") }}
                </v-btn>
              </template>

              <v-list>
                <v-list-item link @click="onAddBen">
                  <v-list-item-title
                    ><v-icon class="mb-1 me-2"> mdi-account-tie</v-icon>
                    {{ $t("personal") }}</v-list-item-title
                  >
                </v-list-item>
                <v-list-item link @click="onAddBusBen">
                  <v-list-item-title
                    ><v-icon class="mb-1 me-2">mdi-briefcase-account</v-icon
                    >{{ $t("business") }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <v-col lg="6" sm="12" class="">
            <v-text-field
              v-model="search"
              append-icon="mdi-filter"
              :placeholder="$t('search_to_filter')"
              class="mb-2 mt-5"
              color="primary"
              outlined
              hide-details
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12">
        <v-data-table
          :headers="recipientHeaders"
          :items="receipientList"
          :single-select="true"
          :search="search"
          :items-per-page="3"
          :scrollable="true"
          item-key="receiver_id"
          v-model="receipientDetails"
          :loading="isLoading"
          loading-text="Loading... Please wait"
          class="elevation-1 recipent row-height-50"
          ref="reciepiet"
          @click:row="handleRowSelect"
          dense
          item-class="style-1"
        >
          <template v-slot:item.receiver_type_data.value="{ item }">
            <v-chip
              small
              outlined
              :color="
                item.receiver_type_data &&
                item.receiver_type_data.user_type == 'IND'
                  ? 'primary'
                  : 'Info'
              "
            >
              {{ item.receiver_type_data ? item.receiver_type_data.value : "" }}
            </v-chip>
          </template>
          <template v-slot:item.full_name="{ item }">
            <span class="font-weight-bold">{{ item.full_name }}</span>
            <p class="mb-0">{{ item.relationship_data ? item.relationship_data.value : "" }}</p>
          </template>
          <template v-slot:item.bank="{ item }">
            <span>
              {{ item.location_name ? item.location_name : "" }}
            </span>
            <p class="mb-0">Account No: {{ item.bank_account_no }}</p>
            <p class="mb-0">Branch Code: {{ item.branch_code }}</p>
          </template>
          <template v-slot:item.action="{ item }">
            <v-radio-group v-model="isSelected">
              <v-radio
                color="primary"
                :key="item.receiver_id"
                :value="item.receiver_id"
              >
              </v-radio>
            </v-radio-group>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" md="12">
        <v-btn
          class="float-left mt-5 px-5 text-capitalize"
          outlined
          color="primary"
          @click="onClickBack"
          ><v-icon dark left>mdi-arrow-left</v-icon>Back</v-btn
        >
        <v-btn
          class="float-right mt-5 px-5 text-capitalize"
          outlined
          color="primary"
          :disabled="!isSelected"
          @click="onClickNext"
          >Next <v-icon dark right>mdi-arrow-right</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import agentService from "@/services/agentService/AgentService.js";
// import { EventBus } from "../../../plugins/events.js";
import Beneficiary from "@/views/beneficiary/CreateBeneSendMoney.vue";
import BusBeneficiary from "@/views/beneficiary/createBusBeneficiary.vue";

export default {
  name: "Recipient",
  data() {
    return {
      isSelected: null,
      selected: [],
      isLoading: false,
      beneficiaryRequestId: 0,
      search: "",
      isAddBen: false,
      recievedPolicy_number: "",
      receipientDetails: [],
      receipientList: [],
      recipientHeaders: [
        {
          text: "",
          value: "action",
          align: "center",
        },
        {
          text: this.$t("name"),
          value: "full_name",
          align: "left",
        },
        {
          text: this.$t("country"),
          value: "country_data.name",
          align: "left",
        },
        {
          text: "User Type",
          value: "receiver_type_data.value",
          align: "left",
        },
        {
          text: this.$t("bank_details"),
          value: "bank",
          align: "left",
        },
        {
          text: this.$t("paymentType"),
          value: "payment_data.value",
          align: "left",
        },
      ],
      country_obj: [],
      showDialog: false,
      showBusDialog: false,
    };
  },
  components: { Beneficiary, BusBeneficiary },
  computed: {
    receipientListItems() {
      return this.$store.state.receipientListItems;
    },
  },
  mounted() {},
  watch: {
    //to watch store value to call Beneficiary list api
    "$store.state.paymodeCountry": function () {
      if (this.$store.state.paymodeCountry.country.country_code === "IND") {
        this.getBenficaryDetails(
          this.$store.state.paymodeCountry.country.country_code,
          this.$store.state.paymodeCountry.paymode
        );
      } else {
        this.getBenficaryDetails(
          this.$store.state.paymodeCountry.country.country_code,
          this.$store.state.paymodeCountry.paymode
        );
      }
    },
    "$store.state.CreatedBeneDetails": function () {
      let createdBeneDetails = this.$store.state.CreatedBeneDetails;
      if (createdBeneDetails.country_code && createdBeneDetails.payment_code) {
        this.getBenficaryDetails(
          createdBeneDetails.country_code,
          createdBeneDetails.payment_code
        );
      }
      this.isSelected = createdBeneDetails.receiver_id;
    },
    serviceCharge: {
      immediate: true,
      handler(val) {
        console.log("servicecharge from watcher: ", val);
        if (Object.values(val).includes(undefined)) {
          return;
        } else {
          this.getBenficaryDetails(
            val.country_name,
            val.selected_service_charge?.data
          );
        }
      },
    },
  },
  props: {
    beneficiaryData: {
      type: Object,
      default: () => {},
    },
    target_currency: {
      type: String,
      default: () => "",
    },
    serviceCharge: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    closeDialog(val) {
      console.log(val);
      this.showDialog = val;
    },
    closeBusDialog(val) {
      console.log(val);
      this.showBusDialog = val;
    },
    getIndCountry(val) {
      let valuwe = "";
      this.country_obj.map((i) => {
        if (val === i.isoAlpha3) {
          valuwe = i.isoAlpha2;
        }
      });
      return valuwe;
    },
    handleRowSelect(item, row) {
      console.log(this.$refs.reciepiet);
      console.log("row", row);
      row.select(true);
      this.receipientDetails = [{ ...item }];
      this.isSelected = item.receiver_id;
    },
    onAddBen() {
      this.showDialog = true;
      this.$store.state.showDialog = true;
    },
    onAddBusBen() {
      this.showBusDialog = true;
      this.$store.state.showDialog = true;
    },
    async getBenficaryDetails(country_name, payment_mode) {
      const requestId = ++this.beneficiaryRequestId;
      this.isLoading = true;

      try {
        const responseData = await agentService.getremitteeListByCntry({
          customer_id: this.$route.query.customerid,
          country_cd: country_name
            ? country_name
            : this.$store.state.paymodeCountry.country.country_code,
          payment_mode: payment_mode
            ? payment_mode
            : this.$store.state.paymodeCountry.paymode,
        });
        if (requestId !== this.beneficiaryRequestId) return;

        const beneficiaries =
          responseData.data.status_code === 200 &&
          Array.isArray(responseData.data.data)
            ? responseData.data.data
            : [];
        this.receipientList = [...beneficiaries].reverse();
        this.receipientDetails = this.receipientList.length
          ? [this.receipientList[0]]
          : [];
        this.isSelected = this.receipientList.length
          ? this.receipientList[0].receiver_id
          : null;
      } catch (e) {
        console.log(e);
        if (requestId === this.beneficiaryRequestId) {
          this.receipientList = [];
          this.receipientDetails = [];
          this.isSelected = null;
        }
      } finally {
        if (requestId === this.beneficiaryRequestId) this.isLoading = false;
      }
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    onClickNext() {
      this.$emit("onNextClick", {
        reciepient: { ...this.receipientDetails[0] },
      });
    },
  },
};
</script>

<style lang="scss">
.v-custome-btn {
  border-radius: 10px !important;
}

.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: auto !important;
  min-height: 2px !important;
}

.text-col {
  color: rgb(130, 127, 127);
  font-size: 12px;
}
.center {
  justify-content: center;
  align-items: center;
}
.width-100 {
  width: 78vw;
}
.v-dialog {
  margin: 0px;
}
tr.v-data-table__selected {
  background: rgb(253, 224, 197) !important;
}
</style>
